export default function getComponentStylesFromString(cssString) {
  const styles = {};

  try {
    cssString
      .split(";")
      .filter(Boolean)
      .map((style) => {
        const [name, value] = style.split(":");
        const camelCaseName = name
          .trim()
          .replace(/-([a-z])/g, (g) => g[1].toUpperCase());

        styles[camelCaseName] = value.trim();
      });
  } catch (error) {
    // TODO: https://asosmobile.atlassian.net/browse/WD-26670
  }

  return styles;
}
